import { render, staticRenderFns } from "./DashboardContactList.vue?vue&type=template&id=df6b8444&"
import script from "./DashboardContactList.vue?vue&type=script&lang=js&"
export * from "./DashboardContactList.vue?vue&type=script&lang=js&"
import style0 from "./DashboardContactList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports